// Document Vault store — per-company, admin-editable.
// Stores a list of categories (vaults) and a list of documents, each
// belonging to one category.
//
// When Supabase is wired, swap the storage layer with tables
// `document_vault_categories` and `document_vault_documents`.

const STORAGE_PREFIX = 'finkloz_docs_';
const CHANGE_EVENT = 'finkloz:docs-changed';

function key(companyId) {
  return STORAGE_PREFIX + (companyId || 'default');
}

const DEFAULT_CATEGORIES = ['Finance', 'Governance', 'Board', 'IP', 'Legal'];

function loadBaseline() {
  // Pull the existing investorData fallback if present so the vault
  // has realistic sample content on first load.
  try {
    // eslint-disable-next-line global-require
    const { DOCUMENTS } = require('./investorData');
    if (Array.isArray(DOCUMENTS) && DOCUMENTS.length) {
      return {
        categories: Array.from(new Set([...DEFAULT_CATEGORIES, ...DOCUMENTS.map(d => d.category).filter(Boolean)])),
        documents: DOCUMENTS.map(d => ({ ...d, id: String(d.id || newDocId()) })),
      };
    }
  } catch { /* ignore */ }
  return { categories: DEFAULT_CATEGORIES, documents: [] };
}

export function getDocVault(companyId) {
  try {
    const raw = localStorage.getItem(key(companyId));
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed && Array.isArray(parsed.categories) && Array.isArray(parsed.documents)) {
        return parsed;
      }
    }
  } catch { /* ignore */ }
  return loadBaseline();
}

export function saveDocVault(companyId, vault) {
  try {
    localStorage.setItem(key(companyId), JSON.stringify(vault));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('saveDocVault failed', e);
  }
}

export function subscribeToDocVaultChanges(callback) {
  const handler = () => callback();
  window.addEventListener(CHANGE_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}

export function newDocId() {
  return 'doc-' + Math.random().toString(36).slice(2, 9);
}
